import admin from './admin.json';
import auth from './auth.json';
import clientSuccess from './client_success.json';
import common from './common.json';
import components from './components.json';
import content from './content.json';
import emptyStates from './empty_states.json';
import feed from './feed.json';
import groups from './groups.json';
import invites from './invites.json';
import leaderboard from './leaderboard.json';
import messages from './messages.json';
import onboarding from './onboarding.json';
import parameters from './parameters.json';
import posting from './posting.json';
import reports from './reports.json';
import search from './search.json';
import sharing from './sharing.json';
import user from './user.json';
import walkthrough from './walkthrough.json';

export {
  admin,
  auth,
  clientSuccess,
  common,
  components,
  content,
  emptyStates,
  feed,
  groups,
  invites,
  leaderboard,
  messages,
  onboarding,
  parameters,
  posting,
  search,
  sharing,
  user,
  reports,
  walkthrough,
};
